import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import router from './router'
import axios from 'axios'
import VueSweetalert2 from 'vue-sweetalert2'

import PrimeVue from 'primevue/config'
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import Dialog from 'primevue/dialog';
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import Skeleton from "primevue/skeleton";

import 'primevue/resources/themes/lara-light-teal/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './registerServiceWorker'
import 'typeface-poppins'
import 'sweetalert2/dist/sweetalert2.min.css'

import './app.css'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(PrimeVue, {
    ripple: true,
    inputStyle: "filled",
})
app.use(ConfirmationService);
app.use(ToastService);
app.use(VueSweetalert2)
app.use(Toast)

app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('ConfirmPopup', ConfirmPopup)
app.component('Button', Button)
app.component('Skeleton', Skeleton)

app.use(router)
app.use(pinia)
const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

axios.defaults.baseURL = isLocalhost
    ? 'http://localhost:8000/api'
    : 'https://api.onlinedobrasil.com/api';

app.config.globalProperties.$axios = axios
app.mount('#app')
